(function () {
  'use strict';

  var locale = (document.documentElement.lang || 'fr').toLowerCase();
  if (locale.indexOf('-') !== -1) locale = locale.split('-')[0];
  var country = (window.Shopify && window.Shopify.country || '').toUpperCase();

  var copy = {
    fr: {
      size: 'Choisissez votre taille', canvas: 'Choisissez votre toile', colors: 'Choisissez le nombre de couleurs',
      popular: 'La plus populaire ✨', beginner: 'Pour débuter', plus6: '+6 h de peinture', plus12: '+12 h de peinture',
      chosen: '♥ La plus choisie', upload: 'Ajoutez votre photo', uploadColors: 'Choisissez vos couleurs',
      remove: 'Supprimer la photo', collections: 'Nos collections', scroll: 'Retour en haut',
      kitContents: 'Contenu du coffret Maison Artsen', paintQuality: 'Détails des peintures et des numéros Maison Artsen',
      canvasOptions: 'Toile roulée ou toile sur cadre en bois', customerGallery: 'Tableaux réalisés par les clients Maison Artsen',
      customerReviews: 'Avis de clients Maison Artsen', rating: '5 étoiles sur 5', productImage: 'Coffret créatif Maison Artsen',
      free: 'Offert', perPainting: 'soit [price]/peinture'
    },
    en: {
      size: 'Choose your size', canvas: 'Choose your canvas', colors: 'Choose the number of colours',
      popular: 'Most popular ✨', beginner: 'Great for beginners', plus6: '+6 hours of painting', plus12: '+12 hours of painting',
      chosen: '♥ Customer favourite', upload: 'Add your photo', uploadColors: 'Choose your colours',
      remove: 'Remove photo', collections: 'Our collections', scroll: 'Back to top',
      kitContents: 'Inside the Maison Artsen set', paintQuality: 'Maison Artsen paints and numbered canvas details',
      canvasOptions: 'Rolled canvas and canvas on a wooden frame', customerGallery: 'Paintings made by Maison Artsen customers',
      customerReviews: 'Maison Artsen customer reviews', rating: '5 out of 5 stars', productImage: 'Maison Artsen creative set',
      free: 'Free', perPainting: '[price] per painting'
    },
    de: {
      size: 'Wähle deine Größe', canvas: 'Wähle deine Leinwand', colors: 'Wähle die Anzahl der Farben',
      popular: 'Am beliebtesten ✨', beginner: 'Ideal für Einsteiger', plus6: '+6 Std. Malzeit', plus12: '+12 Std. Malzeit',
      chosen: '♥ Am häufigsten gewählt', upload: 'Lade dein Foto hoch', uploadColors: 'Wähle deine Farben',
      remove: 'Foto entfernen', collections: 'Unsere Kollektionen', scroll: 'Nach oben',
      kitContents: 'Inhalt des Maison Artsen Sets', paintQuality: 'Farben und nummerierte Leinwand von Maison Artsen',
      canvasOptions: 'Gerollte Leinwand und Leinwand auf Holzrahmen', customerGallery: 'Bilder von Maison Artsen Kunden',
      customerReviews: 'Kundenbewertungen zu Maison Artsen', rating: '5 von 5 Sternen', productImage: 'Kreativset von Maison Artsen',
      free: 'Gratis', perPainting: '[price] pro Bild'
    },
    es: {
      size: 'Elige el tamaño', canvas: 'Elige el lienzo', colors: 'Elige el número de colores',
      popular: 'Más popular ✨', beginner: 'Ideal para empezar', plus6: '+6 h de pintura', plus12: '+12 h de pintura',
      chosen: '♥ La más elegida', upload: 'Añade tu foto', uploadColors: 'Elige los colores',
      remove: 'Eliminar foto', collections: 'Nuestras colecciones', scroll: 'Volver arriba',
      kitContents: 'Contenido del set Maison Artsen', paintQuality: 'Pinturas y lienzo numerado de Maison Artsen',
      canvasOptions: 'Lienzo enrollado y lienzo con bastidor de madera', customerGallery: 'Cuadros de clientes de Maison Artsen',
      customerReviews: 'Opiniones de clientes de Maison Artsen', rating: '5 de 5 estrellas', productImage: 'Set creativo Maison Artsen',
      free: 'Gratis', perPainting: '[price] por cuadro'
    },
    it: {
      size: 'Scegli il formato', canvas: 'Scegli la tela', colors: 'Scegli il numero di colori',
      popular: 'Più popolare ✨', beginner: 'Ideale per iniziare', plus6: '+6 ore di pittura', plus12: '+12 ore di pittura',
      chosen: '♥ Il più scelto', upload: 'Carica la tua foto', uploadColors: 'Scegli i colori',
      remove: 'Rimuovi la foto', collections: 'Le nostre collezioni', scroll: 'Torna in alto',
      kitContents: 'Contenuto del set Maison Artsen', paintQuality: 'Colori e tela numerata Maison Artsen',
      canvasOptions: 'Tela arrotolata e tela su telaio in legno', customerGallery: 'Quadri realizzati dai clienti Maison Artsen',
      customerReviews: 'Recensioni dei clienti Maison Artsen', rating: '5 stelle su 5', productImage: 'Set creativo Maison Artsen',
      free: 'In omaggio', perPainting: '[price] per quadro'
    },
    nl: {
      size: 'Kies je formaat', canvas: 'Kies je canvas', colors: 'Kies het aantal kleuren',
      popular: 'Populairst ✨', beginner: 'Ideaal om te beginnen', plus6: '+6 uur schildertijd', plus12: '+12 uur schildertijd',
      chosen: '♥ Meest gekozen', upload: 'Voeg je foto toe', uploadColors: 'Kies je kleuren',
      remove: 'Foto verwijderen', collections: 'Onze collecties', scroll: 'Terug naar boven',
      kitContents: 'Inhoud van de Maison Artsen set', paintQuality: 'Verf en genummerd canvas van Maison Artsen',
      canvasOptions: 'Opgerold canvas en canvas op houten frame', customerGallery: 'Schilderijen van klanten van Maison Artsen',
      customerReviews: 'Klantbeoordelingen van Maison Artsen', rating: '5 van de 5 sterren', productImage: 'Creatieve set van Maison Artsen',
      free: 'Gratis', perPainting: '[price] per schilderij'
    },
    pt: {
      size: 'Escolha o tamanho', canvas: 'Escolha a tela', colors: 'Escolha o número de cores',
      popular: 'Mais popular ✨', beginner: 'Ideal para começar', plus6: '+6 h de pintura', plus12: '+12 h de pintura',
      chosen: '♥ A mais escolhida', upload: 'Adicione a sua fotografia', uploadColors: 'Escolha as cores',
      remove: 'Remover fotografia', collections: 'As nossas coleções', scroll: 'Voltar ao topo',
      kitContents: 'Conteúdo do conjunto Maison Artsen', paintQuality: 'Tintas e tela numerada Maison Artsen',
      canvasOptions: 'Tela enrolada e tela em bastidor de madeira', customerGallery: 'Quadros de clientes Maison Artsen',
      customerReviews: 'Opiniões de clientes Maison Artsen', rating: '5 de 5 estrelas', productImage: 'Conjunto criativo Maison Artsen',
      free: 'Grátis', perPainting: '[price] por quadro'
    }
  }[locale] || null;

  if (!copy) return;

  if (locale === 'en' && country === 'US') {
    copy.colors = 'Choose the number of colors';
    copy.uploadColors = 'Choose your colors';
  }

  var shippingFaq = locale === 'en' ? {
    US: 'Tracked and insured shipping to the United States is $3.99, and it’s free on orders over $69. The exact charge is always shown before payment. Taxes and customs duties are included in the price, so there is nothing extra to pay on delivery.',
    GB: 'Shipping to the United Kingdom is £4.95, and it’s free on orders over £70. The exact charge is always shown before payment. Taxes and customs duties are included in the price, so there is nothing extra to pay on delivery.',
    AU: 'Shipping to Australia is A$9.95, and it’s free on orders over A$100. The exact charge is always shown before payment. Taxes and customs duties are included in the price, so there is nothing extra to pay on delivery.',
    CA: 'Shipping to Canada is CA$9.95, and it’s free on orders over CA$100. Tracked and insured shipping is available for CA$14.95. The exact charge is always shown before payment. Taxes and customs duties are included in the price, so there is nothing extra to pay on delivery.'
  }[country] || null : null;

  var facetCopy = {
    en: {
      "Calendrier de l'avent": 'Advent calendar', 'Coffret 4 mini-toiles': 'Set of 4 mini canvases',
      'Coffret 6 mini-toiles': 'Set of 6 mini canvases', 'Pancarte 20 × 14 cm': 'Door sign 8 × 5.5 in', 'Toile': 'Canvas', 'Confirmé': 'Advanced',
      'Débutant': 'Beginner', 'Intermédiaire': 'Intermediate', 'Bleus': 'Blues',
      'Coloré & vif': 'Colorful & bright', 'Pastel': 'Pastels', 'Roses': 'Pinks', 'Sombre': 'Dark',
      'Tons chauds': 'Warm tones', 'Tons froids': 'Cool tones', 'Verts': 'Greens', 'Abstrait': 'Abstract',
      'Affiche vintage': 'Vintage poster', 'Aquarelle': 'Watercolor', 'Art naïf': 'Folk art',
      'Cartoon & Kawaii': 'Cartoon & kawaii', 'Illustration moderne': 'Modern illustration',
      'Impressionniste': 'Impressionist', 'Pop art': 'Pop art', 'Réaliste': 'Realistic'
    },
    de: {
      "Calendrier de l'avent": 'Adventskalender', 'Coffret 4 mini-toiles': 'Set mit 4 Mini-Leinwänden',
      'Coffret 6 mini-toiles': 'Set mit 6 Mini-Leinwänden', 'Toile': 'Leinwand', 'Confirmé': 'Fortgeschritten',
      'Débutant': 'Anfänger', 'Intermédiaire': 'Mittelstufe', 'Bleus': 'Blautöne',
      'Coloré & vif': 'Farbenfroh & leuchtend', 'Pastel': 'Pastelltöne', 'Roses': 'Rosatöne', 'Sombre': 'Dunkel',
      'Tons chauds': 'Warme Töne', 'Tons froids': 'Kühle Töne', 'Verts': 'Grüntöne', 'Abstrait': 'Abstrakt',
      'Affiche vintage': 'Vintage-Poster', 'Aquarelle': 'Aquarell', 'Art naïf': 'Naive Kunst',
      'Cartoon & Kawaii': 'Cartoon & Kawaii', 'Illustration moderne': 'Moderne Illustration',
      'Impressionniste': 'Impressionistisch', 'Pop art': 'Pop-Art', 'Réaliste': 'Realistisch'
    },
    es: {
      "Calendrier de l'avent": 'Calendario de Adviento', 'Coffret 4 mini-toiles': 'Set de 4 minilienzos',
      'Coffret 6 mini-toiles': 'Set de 6 minilienzos', 'Toile': 'Lienzo', 'Confirmé': 'Avanzado',
      'Débutant': 'Principiante', 'Intermédiaire': 'Intermedio', 'Bleus': 'Azules',
      'Coloré & vif': 'Colorido y vivo', 'Pastel': 'Pasteles', 'Roses': 'Rosas', 'Sombre': 'Oscuro',
      'Tons chauds': 'Tonos cálidos', 'Tons froids': 'Tonos fríos', 'Verts': 'Verdes', 'Abstrait': 'Abstracto',
      'Affiche vintage': 'Cartel vintage', 'Aquarelle': 'Acuarela', 'Art naïf': 'Arte naïf',
      'Cartoon & Kawaii': 'Cartoon y kawaii', 'Illustration moderne': 'Ilustración moderna',
      'Impressionniste': 'Impresionista', 'Pop art': 'Pop art', 'Réaliste': 'Realista'
    },
    it: {
      "Calendrier de l'avent": "Calendario dell'Avvento", 'Coffret 4 mini-toiles': 'Set da 4 mini tele',
      'Coffret 6 mini-toiles': 'Set da 6 mini tele', 'Toile': 'Tela', 'Confirmé': 'Avanzato',
      'Débutant': 'Principiante', 'Intermédiaire': 'Intermedio', 'Bleus': 'Blu',
      'Coloré & vif': 'Colorato e vivace', 'Pastel': 'Pastello', 'Roses': 'Rosa', 'Sombre': 'Scuro',
      'Tons chauds': 'Toni caldi', 'Tons froids': 'Toni freddi', 'Verts': 'Verdi', 'Abstrait': 'Astratto',
      'Affiche vintage': 'Poster vintage', 'Aquarelle': 'Acquerello', 'Art naïf': 'Arte naïf',
      'Cartoon & Kawaii': 'Cartoon e kawaii', 'Illustration moderne': 'Illustrazione moderna',
      'Impressionniste': 'Impressionista', 'Pop art': 'Pop art', 'Réaliste': 'Realistico'
    },
    nl: {
      "Calendrier de l'avent": 'Adventskalender', 'Coffret 4 mini-toiles': 'Set van 4 mini-doeken',
      'Coffret 6 mini-toiles': 'Set van 6 mini-doeken', 'Toile': 'Canvas', 'Confirmé': 'Gevorderd',
      'Débutant': 'Beginner', 'Intermédiaire': 'Gemiddeld', 'Bleus': 'Blauwtinten',
      'Coloré & vif': 'Kleurrijk & helder', 'Pastel': 'Pasteltinten', 'Roses': 'Roze tinten', 'Sombre': 'Donker',
      'Tons chauds': 'Warme tinten', 'Tons froids': 'Koele tinten', 'Verts': 'Groentinten', 'Abstrait': 'Abstract',
      'Affiche vintage': 'Vintageposter', 'Aquarelle': 'Aquarel', 'Art naïf': 'Naïeve kunst',
      'Cartoon & Kawaii': 'Cartoon & kawaii', 'Illustration moderne': 'Moderne illustratie',
      'Impressionniste': 'Impressionistisch', 'Pop art': 'Popart', 'Réaliste': 'Realistisch'
    },
    pt: {
      "Calendrier de l'avent": 'Calendário do Advento', 'Coffret 4 mini-toiles': 'Conjunto de 4 minitelas',
      'Coffret 6 mini-toiles': 'Conjunto de 6 minitelas', 'Toile': 'Tela', 'Confirmé': 'Avançado',
      'Débutant': 'Principiante', 'Intermédiaire': 'Intermédio', 'Bleus': 'Azuis',
      'Coloré & vif': 'Colorido e vivo', 'Pastel': 'Pastéis', 'Roses': 'Rosas', 'Sombre': 'Escuro',
      'Tons chauds': 'Tons quentes', 'Tons froids': 'Tons frios', 'Verts': 'Verdes', 'Abstrait': 'Abstrato',
      'Affiche vintage': 'Cartaz vintage', 'Aquarelle': 'Aguarela', 'Art naïf': 'Arte naïf',
      'Cartoon & Kawaii': 'Cartoon e kawaii', 'Illustration moderne': 'Ilustração moderna',
      'Impressionniste': 'Impressionista', 'Pop art': 'Pop art', 'Réaliste': 'Realista'
    }
  }[locale] || {};

  var uploadKitCopy = {
    en: {
      language: 'en', required: 'Please upload a photo before adding this item to your cart.',
      add: 'Add a photo', choose: 'Click here to choose your photo', change: 'Change photo',
      android: 'If you have trouble uploading, tap ⋮ in the top-right corner, then choose “Open in Chrome”.',
      ios: 'If you have trouble uploading, tap ⋯, then choose “Open in Browser”.'
    },
    de: { language: 'de', required: 'Bitte lade ein Foto hoch, bevor du den Artikel in den Warenkorb legst.', add: 'Foto hinzufügen', choose: 'Hier klicken und Foto auswählen', change: 'Foto ändern' },
    es: { language: 'es', required: 'Sube una foto antes de añadir este artículo al carrito.', add: 'Añadir una foto', choose: 'Haz clic aquí para elegir tu foto', change: 'Cambiar foto' },
    it: { language: 'it', required: 'Carica una foto prima di aggiungere questo articolo al carrello.', add: 'Aggiungi una foto', choose: 'Clicca qui per scegliere la tua foto', change: 'Cambia foto' },
    nl: { language: 'nl', required: 'Upload een foto voordat je dit artikel aan je winkelmand toevoegt.', add: 'Foto toevoegen', choose: 'Klik hier om je foto te kiezen', change: 'Foto wijzigen' },
    pt: { language: 'pt', required: 'Carregue uma fotografia antes de adicionar este artigo ao carrinho.', add: 'Adicionar fotografia', choose: 'Clique aqui para escolher a sua fotografia', change: 'Alterar fotografia' }
  }[locale] || null;

  function localizeUploadKitConfig() {
    if (!uploadKitCopy || !window.UploadKit || !window.UploadKit.config) return false;
    window.UploadKit.config.enableMultiLanguage = true;
    (window.UploadKit.config.uploaders || []).forEach(function (uploader) {
      uploader.language = uploadKitCopy.language;
      uploader.requiredMessage = uploadKitCopy.required;
      uploader.requiredButtonText = uploadKitCopy.add;
      uploader.buttonText = uploadKitCopy.choose;
      uploader.buttonUploadedText = uploadKitCopy.change;
      if (uploadKitCopy.android) uploader.androidFbMessage = uploadKitCopy.android;
      if (uploadKitCopy.ios) uploader.iosFbMessage = uploadKitCopy.ios;
    });
    return true;
  }

  var uploadKitAttempts = 0;
  var uploadKitTimer = window.setInterval(function () {
    uploadKitAttempts += 1;
    if (localizeUploadKitConfig() || uploadKitAttempts >= 100) window.clearInterval(uploadKitTimer);
  }, 10);

  function cssText(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  var style = document.createElement('style');
  style.setAttribute('data-ma-localization-fixes', locale);
  style.textContent = [
    // Native numbered labels already contain their translated heading.
    'variant-selects:has([id*="option_3_label_container"]) .product-form__label-container:has(.form__label-text)::after{content:none!important}',
    'variant-selects:has([id*="option_3_label_container"]) [id*="option_1_label_container"]:not(:has(.form__label-text))::after{content:"' + cssText(copy.size) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) [id*="option_2_label_container"]:not(:has(.form__label-text))::after{content:"' + cssText(copy.canvas) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) [id*="option_3_label_container"]:not(:has(.form__label-text))::after{content:"' + cssText(copy.colors) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) .product-form__input--pills input[value="Toile sur châssis"]+label::before{content:"' + cssText(copy.popular) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) input[value="24 couleurs"]+label::after{content:"' + cssText(copy.beginner) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) input[value="36 couleurs"]+label::after{content:"' + cssText(copy.plus6) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) input[value="48 couleurs"]+label::after{content:"' + cssText(copy.plus12) + '"!important}',
    'variant-selects:has([id*="option_3_label_container"]) input[value="40×50 cm"]+label::after{content:"' + cssText(copy.chosen) + '"!important}'
  ].join('\n');
  document.head.appendChild(style);

  var exactText = {
    'Choisissez votre taille': copy.size,
    'Choisissez votre toile': copy.canvas,
    'Format de la toile': locale === 'fr' ? 'Format de la toile' : copy.canvas,
    'Choisissez le nombre de couleurs': copy.colors,
    'Choisissez vos couleurs': copy.uploadColors,
    'Ajoutez votre photo': copy.upload,
    'Pour débuter': copy.beginner,
    '♥ La plus choisie': copy.chosen,
    'La plus populaire ✨': copy.popular,
    '+6 h de peinture': copy.plus6,
    '+12 h de peinture': copy.plus12
  };

  var discountTitles = locale === 'fr' ? {} : {
    '2 achetés = 1 offert': 'Buy 2 kits, get the 3rd free',
    '9 Pinceaux offerts': '9 free brushes',
    '3 Pinceaux offerts': '3 free brushes',
    'Chevalet offert': 'Free easel'
  };

  function translate(root) {
    if (!root || root.nodeType !== 1) return;

    if (shippingFaq) {
      var faqItems = Array.prototype.slice.call(root.querySelectorAll('.ma-faq-item'));
      if (root.matches('.ma-faq-item')) faqItems.unshift(root);
      faqItems.forEach(function (item) {
        var summary = item.querySelector('summary');
        var answer = item.querySelector('.ma-faq-answer');
        if (summary && answer && summary.textContent.trim() === 'How much is shipping?' && answer.textContent.trim() !== shippingFaq) {
          answer.textContent = shippingFaq;
        }
      });
    }

    var textTargets = Array.prototype.slice.call(root.querySelectorAll('.ma-upload-step__txt, .product-form__label-container, .product-form__input--pills label'));
    if (root.matches('.ma-upload-step__txt, .product-form__label-container, .product-form__input--pills label')) textTargets.unshift(root);
    textTargets.forEach(function (element) {
      var textWalker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      var targetNode;
      while ((targetNode = textWalker.nextNode())) {
        var current = targetNode.textContent.trim();
        if (exactText[current] && exactText[current] !== current) targetNode.textContent = targetNode.textContent.replace(current, exactText[current]);
      }
    });

    if (locale !== 'fr') {
      var facetTargets = Array.prototype.slice.call(root.querySelectorAll('.facet-item span'));
      if (root.matches('.facet-item span')) facetTargets.unshift(root);
      facetTargets.forEach(function (element) {
        var current = element.textContent.trim();
        Object.keys(facetCopy).some(function (source) {
          if (current !== source && current.indexOf(source + ' (') !== 0) return false;
          // Guard: writing an identical string (e.g. "Pop art" -> "Pop art") still re-creates the text node,
          // which re-triggers the MutationObserver and locks the page in an endless loop (seen 17 Sep 2026).
          var nextText = element.textContent.replace(source, facetCopy[source]);
          if (nextText !== element.textContent) element.textContent = nextText;
          return true;
        });
      });

      if (uploadKitCopy) {
        var uploadKitTexts = {};
        uploadKitTexts['Veuillez télécharger un fichier avant d\'ajouter le produit à votre panier.'] = uploadKitCopy.required;
        uploadKitTexts['Ajouter une image'] = uploadKitCopy.add;
        uploadKitTexts['Cliquez ICI pour choisir votre photo'] = uploadKitCopy.choose;
        uploadKitTexts["Modifier l'image"] = uploadKitCopy.change;
        var uploadTargets = Array.prototype.slice.call(root.querySelectorAll('.uploadkit, .uploadkit *'));
        if (root.matches('.uploadkit, .uploadkit *')) uploadTargets.unshift(root);
        uploadTargets.forEach(function (element) {
          if (element.children.length) return;
          var current = element.textContent.trim();
          if (uploadKitTexts[current]) element.textContent = element.textContent.replace(current, uploadKitTexts[current]);
        });
      }
    }

    if (locale !== 'fr') {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var textNode;
      while ((textNode = walker.nextNode())) {
        var parent = textNode.parentElement;
        if (!parent || /^(SCRIPT|STYLE|TEXTAREA|OPTION)$/.test(parent.tagName)) continue;
        var trimmed = textNode.textContent.trim();
        if (trimmed === 'Offert' || trimmed === 'Offert*') {
          textNode.textContent = textNode.textContent.replace(trimmed, copy.free + (trimmed.endsWith('*') ? '*' : ''));
        } else if (discountTitles[trimmed]) {
          // Titres des remises automatiques Shopify (non traduisibles côté admin), affichés dans le panier.
          textNode.textContent = textNode.textContent.replace(trimmed, discountTitles[trimmed]);
        } else {
          var priceMatch = trimmed.match(/^soit\s+(.+)\/peinture$/i);
          if (priceMatch) textNode.textContent = textNode.textContent.replace(trimmed, copy.perPainting.replace('[price]', priceMatch[1]));
        }
      }
    }

    var photoButtons = Array.prototype.slice.call(root.querySelectorAll('[aria-label="Supprimer la photo"]'));
    if (root.matches('[aria-label="Supprimer la photo"]')) photoButtons.unshift(root);
    photoButtons.forEach(function (element) {
      element.setAttribute('aria-label', copy.remove);
    });
    root.querySelectorAll('[aria-label="Nos collections"]').forEach(function (element) {
      element.setAttribute('aria-label', copy.collections);
    });

    root.querySelectorAll('a[href^="https://maisonartsen.fr/"], a[href^="http://maisonartsen.fr/"]').forEach(function (element) {
      var url = new URL(element.href);
      element.href = window.location.origin + url.pathname + url.search + url.hash;
    });

    if (locale !== 'fr') {
      var pageTitle = document.querySelector('h1');
      var galleryAlt = pageTitle ? pageTitle.textContent.trim() : '';
      var images = Array.prototype.slice.call(root.querySelectorAll('img[alt]'));
      if (root.matches('img[alt]')) images.unshift(root);
      images.forEach(function (image) {
        var source = image.getAttribute('src') || '';
        var alt = image.getAttribute('alt') || '';
        var translatedAlt = '';
        // Keep native English alt text; only repair French fallbacks.
        if (alt.toLowerCase() !== '5 étoiles sur 5' && !/\b(peinture|toile|coffret|pinceaux?|numéro|étoiles?|clientes?|livraison|cadre)\b/i.test(alt)) return;
        if (source.indexOf('contenu-du-coffret') !== -1) translatedAlt = copy.kitContents;
        else if (source.indexOf('qualite-peintures-numeros') !== -1) translatedAlt = copy.paintQuality;
        else if (source.indexOf('toile-roulee-ou-sur-chassis') !== -1) translatedAlt = copy.canvasOptions;
        else if (source.indexOf('avis-clients-maison-artsen') !== -1) translatedAlt = copy.customerGallery;
        else if (source.indexOf('commentaire-client-maison-artsen') !== -1) translatedAlt = copy.customerReviews;
        else if (alt.toLowerCase() === '5 étoiles sur 5') translatedAlt = copy.rating;
        else if (image.closest('[id^="MediaGallery-"], [id^="sticky-atc-"]') && galleryAlt) translatedAlt = galleryAlt + ' – Maison Artsen';
        else if (/\b(peinture|toile|coffret|pinceaux?|numéro|étoiles?|clientes?|livraison|cadre)\b/i.test(alt)) translatedAlt = copy.productImage;
        if (translatedAlt && image.getAttribute('alt') !== translatedAlt) image.setAttribute('alt', translatedAlt);
      });
    }

    root.querySelectorAll('a, button').forEach(function (element) {
      if (element.textContent.indexOf('accessibility.scroll_to_top') !== -1) {
        element.textContent = copy.scroll;
        element.setAttribute('aria-label', copy.scroll);
      }
    });
  }

  function run() { translate(document.documentElement); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.setTimeout(run, 250);
  window.setTimeout(run, 1000);
  window.setTimeout(run, 2500);
  document.addEventListener('shopify:section:load', run);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        translate(mutation.target.parentElement);
        return;
      }
      if (mutation.type === 'attributes') {
        translate(mutation.target);
        return;
      }
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType === 1) translate(node);
        else if (node.nodeType === 3) translate(node.parentElement);
      });
    });
  }).observe(document.documentElement, { childList: true, characterData: true, attributes: true, attributeFilter: ['alt'], subtree: true });
})();
